module.exports = __webpack_public_path__ + "static/media/waic-jihe.49a43a7e.png";